<template>
  <div class="certificate-result">
    <van-nav-bar :title="title" left-arrow @click-left="$router.back()" />

    <!-- <van-empty v-if="certificates.length === 0" description="暂无证书信息" /> -->
    <van-skeleton
      title
      :row="4"
      :loading="loading"
      style="margin-top: 40px"
    >
      <van-empty v-if="!certificate" description="暂无证书信息" />
      <!-- <div v-else>
      <div
        v-for="(certificate, index) in certificates"
        :key="index"
        class="card"
      >
        <img :src="certificate.avatar" class="avatar" />
        <div class="info">
          <p><strong>姓名：</strong>{{ certificate.name }}</p>
          <p><strong>证书编号：</strong>{{ certificate.certificate }}</p>
          <p v-if="certificate.major">
            <strong>培训专业：</strong>{{ certificate.major }}
          </p>
          <p v-if="certificate.occupation">
            <strong>职业名称：</strong>{{ certificate.occupation }}
          </p>
          <p v-if="certificate.direction">
            <strong>职业方向：</strong>{{ certificate.direction }}
          </p>
          <p><strong>级别：</strong>{{ certificate.level }}</p>
          <p><strong>发证时间：</strong>{{ certificate.issuancetime }}</p>
        </div>
        <van-button
          type="primary"
          size="small"
          @click="downloadCertificate(certificate.certificate)"
        >
          下载 PDF
        </van-button>
      </div>
    </div> -->

      <div class="custom-top" v-else>
        <!-- <div
        v-for="(certificate, index) in certificates"
        :key="index"
        class="custom-card"
      > -->
        <div class="custom-card">
          <div class="card-header">
            <!-- <img :src="certificate.avatar" class="avatar" /> -->

            <van-image :src="certificate.avatar" class="avatar" radius="5%" />
            <div class="card-info">
              <p class="name">{{ certificate.name }}</p>
              <p class="label">证书编号：{{ certificate.certificate }}</p>
              <template v-if="certificate.major">
                <p class="label">培训专业：{{ certificate.major }}</p>
              </template>
              <template v-if="certificate.occupation">
                <p class="label">职业名称：{{ certificate.occupation }}</p>
              </template>
              <template v-if="certificate.direction">
                <p class="label">职业方向：{{ certificate.direction }}</p>
              </template>
              <p class="label">证书级别：{{ certificate.level }}</p>
              <p class="date">发证时间：{{ certificate.issuancetime }}</p>
            </div>
          </div>
          <div class="card-footer" v-if="certificate?.cert">
            <van-button type="info" size="small" @click="handlePreview">
              证书预览
            </van-button>
            <van-button
              style="margin-left: 10px"
              type="primary"
              size="small"
              @click="handleDownload3"
            >
              下载证书
            </van-button>
          </div>
        </div>
      </div>
    </van-skeleton>
    <van-image-preview
      v-if="certificate"
      :images="[certificateSrc]"
      :show-index="false"
      v-model="showImage"
      closeable
    ></van-image-preview>
  </div>
</template>
  
  <script>
import api from "@/api";
// import { saveAs } from "file-saver";
import { jsPDF } from "jspdf";
import simhei from "@/assets/fonts/simhei-normal.js";
import { getStorage } from "@/utils/config";
import axios from "axios";

export default {
  name: "CertificateResult",
  computed: {
    // 获取证书图片绝对路径
    certificateSrc() {
      return this.certificate?.cert
        ? this.certificate?.cert.startsWith("http")
          ? this.certificate?.cert
          : getStorage() + this.certificate?.cert
        : "";
    },
  },
  data() {
    return {
      title: "",
      loading: true,
      certificates: [],
      certificate: null,
      certificateTemplate: "",
      showImage: false, // 控制图片预览
    };
  },
  mounted() {
    this.title =
      this.$route.query.type === "1"
        ? "园区AIGC培训证信息查询结果"
        : "职业资格证查询结果";
    this.certificateTemplate =
      this.$route.query.type === "1"
        ? require("@/assets/images/1.jpg")
        : require("@/assets/images/2.jpg");
    this.fetchCertificates();
  },
  beforeRouteEnter(to, from, next) {
    // console.log("to", to);
    // console.log("from", from);
    if (from.path !== "/certificate" && from.path !== "/preview") {
      next(`/certificate?type=${to.query.type}`);
    } else {
      next();
    }
    // 如果没有从 CertificateSearch 页面跳转过来，跳回 CertificateSearch 页面
    // if (!from.name || from.path !== "/certificate") {
    //   next("/certificate"); // 跳回 CertificateSearch 页面
    // } else {
    //   next();
    // }
  },
  methods: {
    async fetchCertificates() {
      const { type, name, idnumber, phone } = this.$route.query;
      try {
        const params = { type, name, idcard: idnumber, phone };
        console.log("params", params);
        const res = await api.postCert(params);
        console.log("res", res);
        if (res.data.data && res.data.success) {
          console.log("certificate data", res.data.data);
          this.certificate = res.data.data;
          // if (this.$route.query.type === "2") this.certificate.cert = null;
        } else {
          this.$toast.fail("未找到相关证书");
        }
      } catch (err) {
        this.$toast.fail("查询失败，请稍后重试");
      } finally {
        this.loading = false;
      }
    },

    async fetchAigcCertificates() {
      const { name, idnumber, phone } = this.$route.query;
      try {
        const params = { type: "1", name, idcard: idnumber, phone };
        console.log("params", params);
        const res = await api.getAigcCert(params);
        console.log("res", res);
        if (res.data.data && res.data.success) {
          this.certificates = [res.data.data];
          console.log("data", res.data.data);
        } else {
          this.$toast.fail("未找到相关证书");
        }
      } catch (err) {
        this.$toast.fail("查询失败，请稍后重试");
      } finally {
        this.loading = false;
      }
    },

    async fetchQualificationCertificates() {
      const { name, idnumber, phone } = this.$route.query;
      try {
        const params = { type: "2", name, idnumber, phone };
        console.log("params", params);
        const res = await api.getQualificationCert(params);
        if (res.data && res.data.length) {
          this.certificates = res.data;
          console.log("res", res.data);
        } else {
          this.$toast.fail("未找到相关证书");
        }
      } catch (err) {
        this.$toast.fail("查询失败，请稍后重试");
      } finally {
        this.loading = false;
      }
    },

    async handlePreview() {
      this.$router.push({
        path: "/preview",
        query: this.$route.query,
      });
      // this.showImage = true; // 显示图片预览
    },

    async handleDownload() {
      const pdf = new jsPDF({
        orientation: "landscape", // 横向
        unit: "mm",
        format: "a4",
      });

      // 注册中文字体
      pdf.addFileToVFS("simhei.ttf", simhei);
      pdf.addFont("simhei.ttf", "simhei", "normal");
      pdf.setFont("simhei");

      // 获取 PDF 页面大小
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      console.log("pageWidth", pageWidth);
      console.log("pageHeight", pageHeight);

      // 证书类型
      const type = this.$route.query.type;

      // 加载背景图片
      const img = new Image();
      img.src = this.certificateTemplate;
      img.crossOrigin = "anonymous"; // 允许跨域加载

      img.onload = () => {
        pdf.addImage(img, "JPEG", 0, 0, pageWidth, pageHeight);

        // 设置文本样式
        pdf.setFontSize(24);

        // 计算居中位置
        const textX = pageWidth / 2;
        const nameY = pageHeight * 0.45;
        const infoY = pageHeight * 0.5;

        // 绘制证书信息
        pdf.setTextColor(51);
        pdf.text(this.certificate.name, textX, nameY, { align: "center" });
        pdf.setFontSize(18);
        pdf.setTextColor(102);
        if (type === "1") {
          pdf.text(`证书编号：${this.certificate.certificate}`, textX, infoY, {
            align: "center",
          });
          pdf.text(`培训专业：${this.certificate.major}`, textX, infoY + 10, {
            align: "center",
          });
          pdf.text(`证书级别：${this.certificate.level}`, textX, infoY + 20, {
            align: "center",
          });
          pdf.text(
            `发证时间：${this.certificate.issuancetime}`,
            textX,
            infoY + 30,
            { align: "center" }
          );
        } else {
          pdf.text(`证书编号：${this.certificate.certificate}`, textX, infoY, {
            align: "center",
          });
          pdf.text(
            `职业名称：${this.certificate.occupation}`,
            textX,
            infoY + 10,
            {
              align: "center",
            }
          );
          pdf.text(
            `职业方向：${this.certificate.direction}`,
            textX,
            infoY + 20,
            {
              align: "center",
            }
          );
          pdf.text(`证书级别：${this.certificate.level}`, textX, infoY + 30, {
            align: "center",
          });
          pdf.text(
            `发证时间：${this.certificate.issuancetime}`,
            textX,
            infoY + 40,
            { align: "center" }
          );
        }

        // 下载 PDF
        pdf.save(`证书_${this.certificate.certificate}.pdf`);
      };
    },

    async handleDownload2() {
      const pdf = new jsPDF({
        orientation: "landscape", // 横向
        unit: "mm",
        format: "a4",
      });

      // 获取 PDF 页面大小
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      console.log("pageWidth", pageWidth);
      console.log("pageHeight", pageHeight);

      // 加载图片
      const img = new Image();
      img.src = this.certificateSrc;
      img.crossOrigin = "anonymous"; // 允许跨域加载
      img.onload = () => {
        pdf.addImage(img, "PNG", 0, 0, pageWidth, pageHeight);
      };
      img.onerror = () => {
        this.$toast.fail("证书加载失败，请稍后重试");
        return;
      };
      img.onload = () => {
        // 下载 PDF
        pdf.save(`证书_${this.certificate.certificate}.pdf`);
      };
    },

    async downloadCertificateImage() {
      const imageUrl = this.certificateSrc;
      const downloadImage = async () => {
        const response = await axios({
          url: imageUrl,
          method: "GET",
          responseType: "blob", // Important
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "image.jpg"); // 设置下载后的文件名
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      };
      downloadImage();
      //   //   a.click();
      //   //   document.body.removeChild(a);
      //   //   URL.revokeObjectURL(url);
      //   // } else {
      //   //   this.$toast.fail("下载失败，请稍后重试");
      //   // }
      // } catch (err) {
      //   this.$toast.fail("下载失败，请稍后重试");
      // }
    },

    async handleDownload3() {
      // 下载证书图片
      const imageUrl = this.certificateSrc;
      if (!imageUrl) {
        this.$toast.fail("证书文件不存在");
        return;
      }
      try {
        // 使用 axios 获取图片 blob 数据（避免 CORS 阻塞）
        const response = await axios.get(imageUrl, {
          responseType: "blob",
        });

        // 转换为 base64
        const reader = new FileReader();
        reader.readAsDataURL(response.data);

        reader.onload = () => {
          const base64Image = reader.result;

          // 创建 Image 对象获取尺寸
          const img = new Image();
          img.src = base64Image;

          img.onload = () => {
            const imgWidth = img.width;
            const imgHeight = img.height;
            console.log("Image Width:", imgWidth, " Image Height:", imgHeight);

            // 创建 jsPDF 实例，设置页面大小为图片尺寸
            const pdf = new jsPDF({
              orientation: "landscape", // 横向
              unit: "mm",
              format: "a4",
            });

            // 获取 PDF 页面大小
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();

            // 添加图片到 PDF
            pdf.addImage(base64Image, "PNG", 0, 0, pageWidth, pageHeight);

            // 下载 PDF
            pdf.save(`证书_${this.certificate.certificate}.pdf`);
          };
        };

        reader.onerror = (error) => {
          console.error("证书文件读取失败:", error);
        };
      } catch (err) {
        console.error("证书文件下载失败:", err);
        this.$toast.fail("证书文件下载失败，请检查网络或权限");
      }
    },
  },
};
</script>
  
<style scoped>
.certificate-result {
  padding: 20px;
  margin-bottom: 20px;
}
.card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 15px;
}
/* .avatar {
  width: 100px;
  height: 100px;
  border-radius: 50%;
} */
.info {
  flex-grow: 1;
  margin-left: 15px;
}
.info p {
  margin: 5px 0;
}

/* ----------------------------------- */
.custom-top {
  margin-top: 15px;
}

.custom-card {
  display: flex;
  flex-direction: column;
  background: #fff;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 15px;
}
.card-header {
  display: flex;
  align-items: center;
}
.avatar {
  width: 100px;
  height: 150px;
  border-radius: 50%;
  margin-right: 20px;
}
.card-info {
  flex-grow: 1;
}
.name {
  font-weight: bold;
  font-size: 16px;
}
.label {
  color: #666;
  margin: 10px 0;
}
.date {
  color: #666;
  margin: 10px 0;
}
.card-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
</style>
